import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import Paragraph from '../../../../../components/common/Paragraph';

const FundsOriginDeclarationModal = () => {
  const [isModalVisible, setModalVisible] = useState(false);

  const hideModal = () => setModalVisible(false);
  const openModal = () => setModalVisible(true);

  const modalFooter = (
    <Button type="primary" onClick={hideModal}>
      Entendido
    </Button>
  );

  return (
    <>
      <Button
        size="small"
        type="link"
        style={{ paddingLeft: '2px', paddingRight: '2px' }}
        onClick={openModal}
      >
        Declaración de Origen de los Fondos
      </Button>
      <Modal footer={modalFooter} visible={isModalVisible} onCancel={hideModal} width={780}>
        <Paragraph strong>Declaración de origen de fondos</Paragraph>
        <Paragraph align="justify">
          El Cliente declara, voluntariamente y dando fe de la legitimidad de la fuente donde
          proviene los fondos que ingresa a Vantrust Capital Corredores de Bolsa S.A., con el
          propósito de contribuir al combate de delitos provenientes de actividades ilícitas, que:
        </Paragraph>
        <ol style={{ listStyleType: 'upper-roman' }}>
          <li>
            Los recursos que entregue en depósito, provienen de las siguientes fuentes (detalle de
            ocupación, oficio, profesión, actividad, negocio, etc.):
          </li>
          <li>
            Los activos que han sido o serán abonados o depositados a cualquier cuenta bancaria en
            la Républica de Chile no provienen, directa ni indirectamente, de actividades ilícitas y
            dicho abono o depósito no constituye uno de los delitos contemplados en la Ley 19.913, o
            la que la sustituya o reemplace.
          </li>
          <li>
            Los fondos no han sido y no serán abonados o depositados, directa o indirectamente, por
            o a través de las siguientes personas (las &quot;personas prohibidas&quot;):
            <ol>
              <li style={{ listStyleType: 'lower-alpha' }}>
                Terroristas u organizaciones terroristas, incluyendo aquellas personas o entidades
                indicadas en la lista en idioma inglés denominada List of Specially Designated
                Nationals and Blocked Persons emitida por la OFAC del Departamente del Tesoro del
                Gobierno de los Estados Unidos (Treasurey Department&apos;s Office of Foreign Assets
                Control).
              </li>
              <li>Banco pantalla (Banco sin presencia física).</li>
            </ol>
          </li>
          <li>
            Los fondos no han sido y no serán abonados o depositados, directa o indirectamente, por
            o a través de Personas Expuestas políticamente, o que así fuere el caso, ha entregado
            información al respecto a Vantrust Capital Corredores de Bolsa S.A. para que este
            obtenga las correspondientes autorizaciones para operar.
          </li>
          <li>
            El cliente no es una de las personas indicadas en el número III precedente, ni tampoco
            lo son su entidad controladora o sus entidades bajo su control o entidades que tengan su
            mismo controlador.
          </li>
          <li>
            El cliente no es una Persona Expuesta políticamente de las indicadas en el número IV
            precedente.
          </li>
        </ol>
      </Modal>
    </>
  );
};

export default FundsOriginDeclarationModal;
